import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, PhoneIcon, BuildingIcon, LandmarkIcon, PlaneIcon } from 'lucide-react';
import { SiteMap } from './SiteMap';
const distances = [{
  icon: BuildingIcon,
  label: 'Nürnberg Messe',
  time: '40 Min'
}, {
  icon: LandmarkIcon,
  label: 'Bayreuth',
  time: '15 Min'
}, {
  icon: PlaneIcon,
  label: 'Flughafen Nürnberg',
  time: '40 Min'
}];
export function LocationStrip() {
  return <section className="py-20 px-4 w-full bg-[#050505] border-t border-white/5" data-id="element-231">
      <div className="max-w-7xl mx-auto" data-id="element-232">
        <div className="flex flex-wrap justify-center gap-4 mb-16" data-id="element-233">
          {distances.map((dist, idx) => {
          const Icon = dist.icon;
          return <motion.div key={dist.label} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="glass-card px-6 py-3 rounded-full flex items-center gap-3" data-id="element-234">
                <Icon className="w-5 h-5 text-white/60" strokeWidth={1.5} data-id="element-235" />
                <span className="text-white/80 font-medium" data-id="element-236">{dist.label}</span>
                <span className="text-white/40" data-id="element-237">|</span>
                <span className="text-electric-blue font-bold" data-id="element-238">
                  {dist.time}
                </span>
              </motion.div>;
        })}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-239">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col gap-8" data-id="element-240">
            <div data-id="element-241">
              <h3 className="text-3xl font-heading font-bold mb-6 text-white" data-id="element-242">
                Hier finden Sie uns
              </h3>
              <div className="flex items-start gap-4 mb-4" data-id="element-243">
                <div className="w-12 h-12 rounded-full glass-card flex items-center justify-center shrink-0 text-electric-blue" data-id="element-244">
                  <MapPinIcon className="w-6 h-6" data-id="element-245" />
                </div>
                <div data-id="element-246">
                  <p className="text-lg text-white/90 font-medium" data-id="element-247">
                    Euro Rastpark Himmelkron
                  </p>
                  <p className="text-white/60" data-id="element-248">
                    Bayreuther Str. 3<br data-id="element-249" />
                    95502 Himmelkron
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-250">
                <div className="w-12 h-12 rounded-full glass-card flex items-center justify-center shrink-0 text-electric-blue" data-id="element-251">
                  <PhoneIcon className="w-6 h-6" data-id="element-252" />
                </div>
                <div data-id="element-253">
                  <p className="text-lg text-white/90 font-medium" data-id="element-254">Kontakt</p>
                  <a href="tel:+499273501730" className="text-white/60 hover:text-electric-blue transition-colors" data-id="element-255">
                    +49 9273 50173-0
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-256">
            <SiteMap data-id="element-257" />
          </motion.div>
        </div>
      </div>
    </section>;
}